import React, { useEffect, useState } from 'react';
import {
  Avatar, Box, Button, Select, MenuItem, TextField, Typography,
  FormControl, InputLabel, Input
} from '@mui/material';
import { AddNewPostBox, AddNewPostContainer } from '../../styles/optionsStyled';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';

const AddNewPost = ({ changeAddNewPost /*, posts*/ }) => {
  const [editorValue, setEditorValue] = useState('');
  const [title, setTitle] = useState('');
  const [categoryId, setCategoryId] = useState(''); // store numeric ID (or '' when none)
  const [image, setImage] = useState(null);
  const [status, setStatus] = useState('');
  const [allCategories, setAllCategories] = useState([]); // [{id, name}]

  // Load categories once; lets us always have IDs regardless of what "posts" contains
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await axios.get(
          'https://www.top500ai.com/top500ai_wordpress/wp-json/wp/v2/categories?per_page=100',
          { headers: { 'Authorization': 'Basic ' + btoa('veljko:VeljRad847') } }
        );
        setAllCategories(res.data.map(c => ({ id: c.id, name: c.name })));
      } catch (e) {
        console.error('Failed to load categories', e);
      }
    };
    loadCategories();
  }, []);

  const handleEditorChange = (content) => setEditorValue(content);

  const modules = {
    toolbar: [
      [{ size: ['small', 'normal', 'large', 'huge'] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      ['link', 'image'],
      ['clean']
    ]
  };

  const handleFormSubmitData = async (event) => {
    event.preventDefault();

    try {
      // 1) Upload image (optional)
      let imageId = null;
      if (image) {
        const formData = new FormData();
        formData.append('file', image);
        formData.append('alt_text', 'Featured Image of Post');

        const imgRes = await axios.post(
          'https://www.top500ai.com/top500ai_wordpress/wp-json/wp/v2/media',
          formData,
          {
            headers: {
              'Authorization': 'Basic ' + btoa('veljko:VeljRad847'),
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        imageId = imgRes.data?.id ?? null;
      }

      // 2) Create post with numeric category ID
      const payload = {
        title: title,
        content: editorValue,
        status: status === 'Active' ? 'publish' : 'draft',
        categories: categoryId ? [Number(categoryId)] : [],
        ...(imageId ? { featured_media: imageId } : {})
      };

      const postRes = await axios.post(
        'https://www.top500ai.com/top500ai_wordpress/wp-json/wp/v2/posts',
        payload,
        {
          headers: {
            'Authorization': 'Basic ' + btoa('veljko:VeljRad847'),
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Post created:', postRes.data);
    } catch (error) {
      console.error(error);
    }

    changeAddNewPost();
    window.location.reload();
  };

  return (
    <AddNewPostBox>
      <AddNewPostContainer maxWidth='sm'>
        <Typography variant='h6' sx={{ width: '100%', mt: '30px' }}>
          Add New Post
        </Typography>

        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <TextField
            id="title-post"
            value={title}
            label="Title"
            variant="outlined"
            color='info'
            size='medium'
            sx={{ minWidth: '35%' }}
            onChange={(e) => setTitle(e.target.value)}
          />

          <FormControl sx={{ minWidth: '35%' }} size="medium">
            <InputLabel id="category-label" color='info'>Category</InputLabel>
            <Select
              labelId="category-label"
              id="category-select"
              value={categoryId}
              label="Category"
              onChange={(e) => setCategoryId(e.target.value)} // store numeric ID (string -> we cast later)
            >
              {allCategories.map(cat => (
                <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <ReactQuill
          value={editorValue}
          onChange={handleEditorChange}
          theme="snow"
          modules={modules}
        />

        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
          <Box>
            <Typography>Featured Image</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Input
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
                style={{ display: 'none' }}
                inputProps={{ id: 'file-input' }}
              />
              <label htmlFor="file-input">
                <Button variant="contained" color="info" component="span">
                  Choose File
                </Button>
              </label>

              {image && (
                <Box>
                  <Avatar
                    alt="Selected Image"
                    variant="square"
                    src={URL.createObjectURL(image)}
                    sx={{ width: 300, height: 150, mt: '10px' }}
                  />
                </Box>
              )}
            </Box>
          </Box>

          <FormControl sx={{ minWidth: '35%' }} size="medium">
            <InputLabel id="status-label" color='info'>Status</InputLabel>
            <Select
              labelId="status-label"
              id="status-select"
              value={status}
              label="Status"
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Draft">Draft</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', gap: '10px', mb: '30px' }}>
          <Button onClick={changeAddNewPost} variant='contained' color='error'>Cancel</Button>
          <Button onClick={handleFormSubmitData} variant='contained' color='success' type='submit'>Submit</Button>
        </Box>
      </AddNewPostContainer>
    </AddNewPostBox>
  );
};

export default AddNewPost;
